import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { createSiteIcon } from '../../utils/mapUtils';

const SystemMarkers = ({ systems, onSystemClick }) => {
  return (
    <>
      {systems.map((sys) => {
        const lat = parseFloat(sys.system_latitude);
        const lng = parseFloat(sys.system_longitude);

        if (isNaN(lat) || isNaN(lng)) {
          return null;
        }

        return (
          <Marker
            key={sys.composite_key}
            position={[lat, lng]}
            icon={createSiteIcon(sys.status)}
            eventHandlers={{
              click: () => onSystemClick(sys),
            }}
          >
            <Popup>

              {sys.street_name}
              <br />

              {sys.system_type}


            </Popup>
          </Marker>
        );
      })}
    </>
  );
};

export default SystemMarkers;
